import {
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { getViewReturn, SurViewReturnsModel, ViewReturnsParameter } from "@tSurya/Services/ViewReturnListService";

import { CustomApiHandler } from "@tSurya/Store/CustomHandlerCreator/CustomHandlerCreator";

type HandlerType = CustomApiHandler<ViewReturnsParameter, SurViewReturnsModel>;

export const DispatchBeginViewReturn: HandlerType = props => {
    props.dispatch({
        type: "Custom/ViewReturnData/BeginLoadViewReturn",
    });
};
export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};
export const StoreAPIParameterData: HandlerType = props => {
    if (!props.parameter) {
        return;
    }
    props.dispatch({
        type: "Custom/ViewReturnStore/CompletedLoadViewReturnStore",
        searchparameter: props.apiParameter,
    });
};
export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getViewReturn(props.apiParameter);
};

export const DispatchCompleteViewReturn: HandlerType = props => {
    if (!props.apiResult) {
        return;
    }
    props.dispatch({
        type: "Custom/ViewReturn/CompletedLoadViewReturn",
        result: props.apiResult,
    });
};

export const chain = [
    DispatchBeginViewReturn,
    PopulateApiParameter,
    StoreAPIParameterData,
    RequestDataFromApi,
    DispatchCompleteViewReturn,
];

const loadViewData = createHandlerChainRunner(chain, "LoadViewData");
export default loadViewData;
